import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { buttonReset, focusRing } from '../../../../shared/theme/focusStyles';

const DATE_MODES = [
  { value: 'single', label: 'Single date' },
  { value: 'range', label: 'Date range' },
];

const ToggleContainer = styled('div')`
  display: inline-flex;
  border: 2px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.borderLight};
`;

const ToggleButton = styled('button')`
  ${buttonReset}
  padding: 4px 12px;
  border: 2px solid ${({ active, theme }) => (active ? theme.colors.hover : theme.colors.borderLight)};
  border-radius: 4px;
  background: ${({ active, theme }) => (active ? theme.colors.surface : 'transparent')};
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 600;
  color: ${({ active, theme }) => (active ? theme.colors.text : theme.colors.textSecondary)};
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  ${focusRing}
`;

const CopyDateModeToggle = ({
  ariaLabel, idPrefix, panelId, mode, onSelect, onEnterSelect,
}) => {
  const handleClick = (e) => {
    onSelect(e.currentTarget.value);
  };

  /* preventDefault suppresses the native Enter-to-click so the mode isn't set
     twice; Space still selects via onClick without moving focus. */
  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') {
      return;
    }
    e.preventDefault();
    onEnterSelect(e.currentTarget.value, panelId);
  };

  return (
    <ToggleContainer aria-label={ariaLabel} role='tablist'>
      {DATE_MODES.map((option) => (
        <ToggleButton
          active={mode === option.value}
          aria-controls={panelId}
          aria-selected={mode === option.value}
          id={`${idPrefix}-${option.value}`}
          key={option.value}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          role='tab'
          type='button'
          value={option.value}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleContainer>
  );
};

CopyDateModeToggle.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  idPrefix: PropTypes.string.isRequired,
  panelId: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['single', 'range']).isRequired,
  onSelect: PropTypes.func.isRequired,
  onEnterSelect: PropTypes.func.isRequired,
};

export default CopyDateModeToggle;
